import { SmartApp } from './smart-app'

export interface TVApp {
  id: string
  name: string
  iconPath: string
  version: string
  internalApp: any
}

export interface LocalApp {
  id: string
  available: boolean
  iconUrl: string
  smartApp: SmartApp
  tvApp?: TVApp
}

export enum LocalAppLaunchMode {
  APPS = 'APPS',
  BOOT = 'BOOT',
  MENU = 'MENU',
  REMOTE = 'REMOTE',
}
